import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { NotificationService } from '@htx/core';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const isError = (response: HttpResponse<unknown>) => response.status >= 400;

  return next(req).pipe(
    tap((response) => {
      let errorMessage = 'Ein unbekannter Fehler ist aufgetreten';
      if (response instanceof HttpResponse && isError(response)) {
        if (response.body == null) {
          notificationService.showError(errorMessage);
          return;
        }
        if (Array.isArray(response.body)) {
          errorMessage = response.body
            .filter(
              (object): object is { message: string } =>
                typeof object === 'object' && object !== null && 'message' in object
            )
            .map((object) => object.message)
            .filter((message) => message !== null)
            .join('\n');
        } else if (
          typeof response.body === 'object' &&
          response.body !== null &&
          'message' in response.body
        ) {
          errorMessage = (response.body as { message: string }).message;
        }
        if (errorMessage === '' || errorMessage === undefined) {
          errorMessage = 'Ein unbekannter Fehler ist aufgetreten';
        }
        notificationService.showError(errorMessage);
      }
    })
  );
};
